import { defineStore } from "pinia";

interface State {
    token: string;
    name: any;
    roles: object;
    refreshTime: number;
}
/* eslint-disable */
export const useAuthStore = defineStore('auth', {
    state: () => {
        if (localStorage.getItem("piniaState")) {
            // @ts-ignore
            if (JSON.parse(localStorage.getItem("piniaState")).auth) {
                return {
                    // @ts-ignore
                    token: JSON.parse(localStorage.getItem("piniaState")).auth.token,
                    // @ts-ignore
                    name: JSON.parse(localStorage.getItem("piniaState")).auth.name,
                    // @ts-ignore
                    roles: JSON.parse(localStorage.getItem("piniaState")).auth.roles,
                    // @ts-ignore
                    refreshTime: JSON.parse(localStorage.getItem("piniaState")).auth.refreshTime
                }
            } else {
                return {
                    token: "",
                    name: "",
                    roles: {},
                    refreshTime: 0
                }
            }
        } else {
            return {
                token: "",
                name: "",
                roles: {},
                refreshTime: 0
            }
        }
    },
    getters: {},
    actions: {
        setToken(token: string) {
            this.token = token
        },

        setName(name: any) {
            this.name = name
        },

        setRoles(roles: object) {
            this.roles = roles
        },

        setRefreshTime(refreshTime: number) {
            this.refreshTime = refreshTime
        },

        $reset() {
            this.token = ""
            this.name = ""
            this.roles = {}
            this.refreshTime = 0
          }
    }
})
